import { DataGrid, DataGridProps, GridColDef } from "@mui/x-data-grid";
import { useGetLocale } from "@refinedev/core";
import { useMemo, useState } from "react";
import { IconButton } from "@mui/material";
import { useTranslation } from "../../../hooks/useTranslation";
import { trTR, enUS } from "@mui/x-data-grid/locales";
import { useDataGrid } from "@refinedev/mui";
import { useMarketplaceStore } from "../../../store/useMarketplaceStore";
import { HtmlModal } from "./components/HtmlModal";
import { Preview } from "@mui/icons-material";
import { SyncrosaleLoader } from "../../../components/layout/components/SyncrosaleLoader";
export const ForwardedMailsList = () => {
  const locale = useGetLocale();
  const currentLocale = locale();
  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);
  const { translate } = useTranslation(
    "pages.stores.mailNotification.forwardedMailsList",
  );

  const [openHtml, setOpenHtml] = useState(false);
  const [selectedHtml, setSelectedHtml] = useState<string>("");
  const [isHtml, setIsHtml] = useState<boolean>(false);

  const columns = useMemo<GridColDef[]>(
    () => [
      {
        field: "subject",
        headerName: translate("fields.subject"),
        flex: 2,
      },
      {
        field: "bodyHtml",
        headerName: translate("fields.content"),

        align: "center",
        renderCell: (params) => (
          <IconButton
            color="primary"
            onClick={() => {
              const html = params.row.bodyHtml || params.row.bodyPlain;

              setIsHtml(!!params.row.bodyHtml);
              setSelectedHtml(html);

              setOpenHtml(true);
            }}
          >
            <Preview fontSize="medium" />
          </IconButton>
        ),
      },
      {
        field: "sender",
        headerName: translate("fields.sender"),
        flex: 1,
      },
      {
        field: "recipient",
        headerName: translate("fields.recipient"),
        flex: 1,
      },
      {
        field: "receivedDate",
        headerName: translate("fields.receivedDate"),
        minWidth: 180,
        valueFormatter: (value: string) => {
          const date = new Date(value).toLocaleDateString(currentLocale);
          const time = new Date(value).toLocaleTimeString(currentLocale);
          return `${date} ${time}`;
        },
      },
    ],
    [translate, currentLocale],
  );

  const {
    dataGridProps,
    tableQuery: { isInitialLoading },
  } = useDataGrid({
    resource: `store/${selectedCountry?.id}/notification-mail`,
    queryOptions: {
      enabled: !!selectedCountry,
    },
    sorters: {
      initial: [
        {
          field: "created",
          order: "desc",
        },
      ],
    },
  });

  if (isInitialLoading) {
    return <SyncrosaleLoader />;
  }

  return (
    <>
      <DataGrid
        {...(dataGridProps as unknown as DataGridProps)}
        sx={{ flex: 1 }}
        columns={columns}
        localeText={
          (currentLocale === "tr" ? trTR : enUS).components.MuiDataGrid
            .defaultProps.localeText
        }
        disableColumnFilter
        disableColumnMenu
      />

      <HtmlModal
        open={openHtml}
        onClose={() => setOpenHtml(false)}
        htmlContent={selectedHtml}
        ishtml={isHtml}
      />
    </>
  );
};
